<ng-container [formGroup]="form">
  <dgx-form-fieldset
    [legend]="'CHECKOUT_TERMS_AND_CONDITIONS_LEGEND' | translate"
    [legendNote]="
      termsAndConditionsLegendNote
        | translate
          : {
              termsAndConditions: quotes | cmsBrandTermsAndConditions
            }
    "
  >
    <dgx-form-row>
      <dgx-form-field
        [dgxTestHook]="testHooks.CheckBox"
        formControlName="termsAndConditions"
      >
        <dgx-form-note
          *dgxFeatureEnabled="ipidFeature; and: isInsuranceContractType"
          [note]="'CHECKOUT_TERMS_AND_CONDITIONS_LEGEND_IPID_NOTE' | translate
          : {
              ipid: quotes | cmsBrandIpid,
            }"
          class="mb-4"
        />

        <dgx-form-checkbox
          [label]="'CHECKOUT_TERMS_AND_CONDITIONS_CHECKBOX_LABEL' | translate"
          [size]="'medium'"
        />
      </dgx-form-field>
    </dgx-form-row>
  </dgx-form-fieldset>
</ng-container>
